import { sendEventLogin } from 'helpers/analytics';
import {
  getChannelContextAdditionalInfo,
  getChannelContextCode,
  getJsonStringify
} from 'helpers/Utility';
import { setError, setIsLogin, setOauthToken } from 'store/actions/auth';
import { loading } from 'store/actions/loanApply';

const handleIncorrectOTP = (err, dispatch, action, phoneNumber) => {
  sendEventLogin({
    action: 'User Input Wrong OTP Login',
    label: `${phoneNumber} - ${getJsonStringify(err.response)}`
  });

  action?.eventName?.(err.response);
  dispatch(setError('incorrect_otp'));
  action?.failed?.();
};

const handleTemporaryLocked = (err, dispatch) => {
  const addInfo = getChannelContextAdditionalInfo(err, 'channel-context');
  const freezeTime = addInfo?.freezeEnd;
  localStorage.setItem('otpFreeze', JSON.stringify({ freezeTime }));
  dispatch(setError('otp_temporary_locked'));
};

const handleNetworkOrSystemError = (err, dispatch) => {
  if (err.toString().includes('Network Error')) {
    dispatch(setError('connection'));
  } else {
    dispatch(setError('system'));
  }

  dispatch(setIsLogin(false));
  dispatch(setOauthToken('', ''));
};

/**
 * Main function to handle validate OTP error
 * @param {} err
 * @param {*} dispatch
 * @param {*} action
 * @param {*} phoneNumber
 * @returns
 */
export const handleErrorValidateOtp = (
  err,
  status,
  dispatch,
  action,
  phoneNumber
) => {
  // Case: Wrong OTP
  if (
    status === 400 &&
    getChannelContextCode(err, 'channel-context') === '100879'
  ) {
    handleIncorrectOTP(err, dispatch, action, phoneNumber);
    return dispatch(loading(false));
  }

  if (
    status === 429 &&
    getChannelContextCode(err, 'channel-context') === '1008'
  ) {
    handleTemporaryLocked(err, dispatch);
    return dispatch(loading(false));
  }

  if (getChannelContextCode(err, 'channel-context') === '105412') {
    dispatch(setError('otp-expired'));
    return dispatch(loading(false));
  }

  // Case: Network error or system error
  if (!err.response) {
    handleNetworkOrSystemError(err, dispatch);
    return dispatch(loading(false));
  }
};
